import { memo, useContext, useEffect, useState } from 'react';
import { MovableTypePrintingContext } from './MovableTypePrintingProvider';
import SvgButton from '../ui/SvgButton';

interface GamePrintingControlConfirmProps {
  onConfirm: (correct: boolean) => void,
}

export default memo(function GamePrintingControlConfirm(props: GamePrintingControlConfirmProps) {
  const { answers, answersUpdated, theText } = useContext(MovableTypePrintingContext);
  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    console.log('GamePrintingControlConfirm 2', answers.filter(ans => ans).length === theText.length);
    setShowBtn(answers.filter(ans => ans).length === theText.length);
  }, [answers, answersUpdated, theText.length]);

  const onConfirm = () => {
    // console.log(theText, answers.map(a => a ?.text).join(''), theText === answers.map(a => a ?.text).join(''));
    props.onConfirm(theText === answers.map(a => a ?.text).join(''));
  }

  return (
    <div className={`game-printing-control${showBtn ? '' : ' game-printing-control-disabled'}`}>
      <button className="game-printing-control-confirm" onClick={onConfirm}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-printing/game3-print-button`} src1=".svg" src2="-select.svg" alt="印刷"></SvgButton>
      </button>
    </div>
  )
})
